export default function(data, url, method, callback, errorCallback, version,token) {

  var serialize = function(obj) {
    var str = [];
    for(var p in obj)
      if (obj.hasOwnProperty(p)) {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
      }
    return str.join("&");
  }

  if(method==="GET"){
    data = serialize(data);
  } else {
    data = JSON.stringify(data);
  }
  var settings = {
    "async": true, 
    "crossDomain": true,
    "url": (version && version == "v4" ? "/v4/" : version ? "/":"/v1/")+url,
    "method": method,
    "type": method,
    "headers": {
      "content-type": "application/json",
    },
    "processData": false,
    "data": data,
    success: function(response, status, xhr){
      if(callback){
        callback(response, xhr);
      }
    },
    error: function(xhr, type){
      if(errorCallback){
        errorCallback(xhr);
      }
    }
  };

  settings.headers["X-CSRF-Token"] = $('meta[name="csrf-token"]').attr('content');

  $.ajax(settings);
}



// WEBPACK FOOTER //
// app/javascript/src/javascripts/common/server-connection.js